import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TheHeaderLoginSignupLogic header-logic" }

import { BaseButton } from 'Components/Base/BaseButton';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeaderAuthButtons',
  emits: ["login-click"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseButton), {
      key: "login-link",
      color: "outlined",
      class: "header-logic__login-button",
      small: "",
      "aria-label": "Click on Log In Link",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('login-click', $event)), ["prevent"]))
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Log In ")
      ])),
      _: 1
    }),
    _createVNode(_unref(BaseButton), {
      key: "signup",
      color: "primary",
      tag: "a",
      small: "",
      href: "/sign-up",
      "aria-label": "Click on Sign Up Button"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" Sign Up ")
      ])),
      _: 1
    })
  ]))
}
}

})